import { useEffect, useState } from "react"
import { configs, generateBase64 } from "../../../assets/Config";
import { useLogin } from "../../../services/contexts/AdminLoginContext";
import TopBarPage from "../../includes/dashboard/TopBarPage";
import LeftBarPage from "../../includes/dashboard/LeftBarPage";
import { useHistory } from 'react-router';
import { addHighlights, getHighlights } from "../../../services/apis/CustomerDashboardManagementApi";
import ToastPage from "../../includes/ToastPage";
import { useBuyOrderContext } from "../../../services/contexts/BuyOrdersContext";
import { Autocomplete } from "@material-ui/lab";
import { TextField } from "@material-ui/core";
import { getCalequityData, postCalequityData } from "../../../services/apis/CalequityManagementApi";

export default function Calequity() {

    const { setCurrModule, allowedFunc, token, setShowSuccess, logout } = useLogin()
    const { getCompanyList } = useBuyOrderContext();

    const history = useHistory()

    const [error, setError] = useState("");
    const [companyList, setCompanyList] = useState("")

    const [dashboardHighlight, setDashboardHighlight] = useState([]);

    useEffect(() => {
        (async () => {
            try {
                setCurrModule(configs.modules.calequity)
                if (allowedFunc.includes(configs.functionList['calequity:calequity'])) {
                    let response = await getCompanyList()
                    if (response.success) {
                        setCompanyList(response.data)
                    } else {

                    }
                    response = await getCalequityData(token);
                    if (response && response.data) {
                        response.data.data?.map(ele=>{
                            Object.keys(ele.data).forEach(key=>{
                                ele[key] = ele.data[key]
                            })
                        })
                        setDashboardHighlight(response.data)
                    }
                } else {
                    history.goBack();
                }
            } catch (error) {
                console.error(error);
            }
        })()
    }, [])


    // handle company change
    const handleCompanyChange = async (e, value, index) => {
        try {
            let duplicate = false;
            dashboardHighlight.forEach((ele) => {
                if (ele.company_id === value.id)
                    duplicate = true;
            })
            if (duplicate) {
                setError("Same company cannot be added as highlight.")
            } else {
                let highlights = dashboardHighlight;
                highlights[index].company_id = value.id;
                setDashboardHighlight([...dashboardHighlight], highlights);
                setError("");
            }
        } catch (error) {
            console.error(error);
        }
    }

    // handle other texts
    function uploadText(key, text, index) {
        try {
            let highlights = dashboardHighlight;
            highlights[index][key] = text
            setDashboardHighlight([...dashboardHighlight], highlights);

        } catch (error) {
            console.error(error)
        }
    }


    // add highlight function
    function modifyHighlight(index, setDelete) {
        try {
            if (setDelete && dashboardHighlight.length > 1) {
                let highlight = dashboardHighlight
                highlight.splice(index, 1);
                setDashboardHighlight([...dashboardHighlight], highlight)
            } else if (dashboardHighlight[dashboardHighlight.length - 1]?.company_id && dashboardHighlight[dashboardHighlight.length - 1]?.risk && dashboardHighlight[dashboardHighlight.length - 1]?.lastPrice && dashboardHighlight[dashboardHighlight.length - 1]?.highlight && dashboardHighlight[dashboardHighlight.length - 1]?.description) {
                let highlight = dashboardHighlight
                highlight.push({
                    company_id: '',
                    risk: '',
                    lastPrice: '',
                    highlight: '',
                    description: ''
                })
                setDashboardHighlight([...dashboardHighlight], highlight)
                setError("");
            } else if (!setDelete) {
                setError("New company component could not be created as above component details are missing")
            }
        } catch (error) {
            console.error(error);
        }
    }


    // save highlight
    async function saveHighLight() {
        try {
            document.getElementById("saveHighlightBtn").classList.toggle("d-none")
            document.getElementById("saveHighlightBtnLoader").classList.toggle("d-none")

            if (dashboardHighlight[dashboardHighlight.length - 1]?.company_id) {
                let response = await postCalequityData(token, dashboardHighlight);
                if (response && response.status === 200) {
                    setError("");
                    setShowSuccess(true)
                } else if (response && response.status === 401) {
                    logout();
                } else {
                    setError(response.data.error);
                }
            } else {
                setError("The data could not be saved as the company id is not there in last component.")
            }
        } catch (error) {
            setError(error.error ? error.error : error)
            console.error(error);
        } finally {
            document.getElementById("saveHighlightBtn").classList.toggle("d-none")
            document.getElementById("saveHighlightBtnLoader").classList.toggle("d-none")
        }
    }

    return (
        <>
            <TopBarPage />
            <div style={{ display: "flex" }}>
                <LeftBarPage />
                <div id='nmContainer' className="smPO-container">
                    <div style={{ width: "100%" }}>
                        <div className="row d-flex align-items-center mt-2 ml-2 mb-4 mr-3">
                            <div className="col-lg-6 text-left">
                                <p className="h4 text-custom-grey">Calequity</p>
                            </div>
                        </div>
                        <div className="smPOI-container">
                            {dashboardHighlight && dashboardHighlight.length > 0 ?
                                dashboardHighlight.map((ele, key) => {
                                    return <div className={`mx-0 px-0 py-2 bg-light ${key > 0 ? "mt-5" : ""}`}>
                                        <div className='row m-0 p-0' key={`dashboardHighlight${key}`}>
                                            <div className='col-md-4'>
                                                <div className="form-group">
                                                    <div className='f-12'>
                                                        <label htmlFor="title" className="font-weight-bold">Select Company</label>
                                                    </div>
                                                    {companyList ? <Autocomplete
                                                        className="f-12"
                                                        id="companyIP"
                                                        placeholder="Compnay Name"
                                                        getOptionLabel={option => option.name}
                                                        onChange={(e, value) => { handleCompanyChange(e, value, key) }}
                                                        options={companyList}
                                                        value={companyList.find(item => item.id === ele.company_id) || ""}
                                                        renderInput={(params) => <TextField {...params} placeholder="Company Name" className="f-12" />}
                                                    /> : null}
                                                    <div className="row m-0 p-0 mt-4">
                                                        <div className="col-md-6 col-12">
                                                            <div className='f-12'>
                                                                <label htmlFor="title" className="font-weight-bold">Select Risk</label>
                                                            </div>
                                                            <select name="" id="" className=" col-12 py-1 px-2 border rounded f-12" value={ele.risk ? ele.risk : "default"} onChange={(e) => {
                                                                uploadText("risk", e.target.value, key)
                                                            }}>
                                                                <option className='f-12' value="default" disabled> ---- </option>
                                                                <option className='f-12' value="Low Risk"> Low Risk</option>
                                                                <option className='f-12' value="Medium Risk"> Medium Risk</option>
                                                                <option className='f-12' value="High Risk"> HIgh Risk</option>
                                                            </select>
                                                        </div>
                                                        <div className="col-md-6 col-12">
                                                            <div className='f-12'>
                                                                <label htmlFor="title" className="font-weight-bold">Last Round Price</label>
                                                            </div>
                                                            <input value={ele.lastPrice} placeholder="Enter Value" className="form-control f-12" onChange={(e) => {
                                                                uploadText("lastPrice", e.target.value, key)
                                                            }} />
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className='col-md-4'>
                                                <div className="form-group">
                                                    <div className='f-12'>
                                                        <label htmlFor="title" className="font-weight-bold">Key Highlights <br></br><span className="f-8">("." separated pointers)</span></label>
                                                    </div>
                                                    <textarea id="keyHIgh" className="form-control f-10" placeholder="Key Highlights" value={ele.highlight} required onChange={(e) => {
                                                        uploadText("highlight", e.target.value, key)
                                                    }} />
                                                </div>
                                            </div>
                                            <div className='col-md-4'>
                                                <div className="form-group">
                                                    <div className="justify-content-end d-flex">
                                                        <button href="#" data-toggle="modal" data-target="#deleteRole" className="btn btn-danger f-10" onClick={(e) => {
                                                            e.preventDefault()
                                                            modifyHighlight(key, true)
                                                        }}><i className="fas fa-trash mr-2 f-10"></i>Delete Component</button>
                                                    </div>
                                                    <div className='f-12'>
                                                        <label htmlFor="title" className="font-weight-bold">Description</label>
                                                    </div>
                                                    <textarea id="description" className="form-control f-10" placeholder="Description" value={ele.description} required onChange={(e) => {
                                                        uploadText("description", e.target.value, key)
                                                    }} />
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                })
                                : null}
                            <div className='row m-0 p-0 mt-3'>
                                <p className="text-danger">{error}</p>
                                <div className='col-12 m-0 p-0 d-flex justify-content-end'>
                                    <div className="form-group d-flex">
                                        <button className="text-primary custom-button" onClick={(e) => {
                                            e.preventDefault()
                                            modifyHighlight()
                                        }}><i className="fas fa-plus-circle mr-2"></i>Add New Company</button>

                                        <div className="">
                                            <button id="saveHighlightBtn" className="btn btn-primary" onClick={(e) => {
                                                e.preventDefault()
                                                saveHighLight()
                                            }}>Update Recommendations</button>
                                            <div id="saveHighlightBtnLoader" className='animBtn d-none'><div className='gSignIn-Anim'></div></div>
                                        </div>
                                    </div>

                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <ToastPage />
        </>
    )
}